import { render } from "./FormApiCapture.vue?vue&type=template&id=b709bb18"
import script from "./FormApiCapture.vue?vue&type=script&lang=js"
export * from "./FormApiCapture.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__